// extracted by mini-css-extract-plugin
module.exports = {"container":"title_container__fMJQ6","text":"title_text__1osXf","left":"title_left__AYLCT","controlAsset":"title_controlAsset__QHBUq"};